import { Component } from '@angular/core';

@Component({
  selector: 'app-gray-zone',
  templateUrl: './gray-zone.component.html',
  styleUrls: ['./gray-zone.component.css'],
})
export class GrayZoneComponent {
  constructor() {}

  public sendEventIframe(): void {}
}
